const state = {
  job:  window.sessionStorage.getItem('userinfo') === null || window.sessionStorage.getItem('userinfo') === '' ? '' : JSON.parse(window.sessionStorage.getItem('userinfo')).job || '',
  uname: window.sessionStorage.getItem('userinfo') === null || window.sessionStorage.getItem('userinfo') === '' ? '' : JSON.parse(window.sessionStorage.getItem('userinfo')).uname || '',
  uphone: window.sessionStorage.getItem('userinfo') === null || window.sessionStorage.getItem('userinfo') === '' ? '' : JSON.parse(window.sessionStorage.getItem('userinfo')).uphone || '',
  uguid: window.sessionStorage.getItem('userinfo') === null || window.sessionStorage.getItem('userinfo') === '' ? '' : JSON.parse(window.sessionStorage.getItem('userinfo')).uguid || ''
}
const actions = {}
const mutations = {
  SET_USER (state, obj) {
    // console.log(obj)
    state.job = obj.job
    state.uname = obj.uname
    state.uphone = obj.uphone
    state.uguid = obj.uguid
    window.sessionStorage.setItem('userinfo', JSON.stringify(obj))
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
